import React, { useEffect, useState } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const WorldData = () => {
  const classes = useStyles();
  const API = "https://coronavirus-19-api.herokuapp.com/countries";
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(API)
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  const renderTable = () => {
    return data.map((data) => {
      return (

        <TableRow>
        <TableCell align="left">{data.country}</TableCell>
        <TableCell align="right">{data.cases}</TableCell>
        <TableCell align="right">{data.todayCases}</TableCell>
        <TableCell align="right">{data.deaths}</TableCell>
        <TableCell align="right">{data.recovered}</TableCell>
        <TableCell align="right">{data.active}</TableCell>
        <TableCell align="right">{data.critical}</TableCell>

        </TableRow>
      );
    });
  };
  return (
    <div className="p-5">
      <h2 className="text-center">World Covid19 Updates</h2>

      <img src="https://i.pinimg.com/564x/46/03/44/46034450e84f4d6f31a032f68a1fb16f.jpg" alt="hospital" className="mx-auto img-fluid  d-block" />
      <div class="table-responsive">
      <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>  
          <TableCell align="left"><h4>Country</h4></TableCell>
          <TableCell align="right"><h4>Total Cases</h4></TableCell>
          <TableCell align="right"><h4>Today Cases</h4></TableCell>
          <TableCell align="right"><h4>Total Deaths</h4></TableCell>
          <TableCell align="right"><h4>Recoverd Cases</h4></TableCell>
          <TableCell align="right"><h4>Active Cases</h4></TableCell>
          <TableCell align="right"><h4>Critical Cases</h4></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {renderTable()}
        </TableBody>
      </Table>
    </TableContainer>
      </div>
    </div>
  );
};

export default WorldData;

